import { api } from "../../../services/api";
import { BOND_HEADER_ACTIONS, BOND_DETAIL_ACTIONS, BOND_PRICE_ACTIONS, BOND_ANALYTICS_ACTIONS, BOND_DETAIL_TOKEN_ACTIONS, SAME_ISSUER_BONDS_ACTIONS } from "../../actionType/bondDetails";
import { bonds } from "../../../services/apiVariables";


export const getBondsHeader =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BOND_HEADER_ACTIONS.BOND_HEADER_REQUEST,
            payload: { isBondsHeaderDetailLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.getBondHeader, body })
                .then((data: any) => {
                    dispatch({ type: BOND_HEADER_ACTIONS.BOND_HEADER_RESPONSE, payload: data });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BOND_HEADER_ACTIONS.BOND_HEADER_ERROR, payload: [] });
                    reject(error);
                });
        });
    };
export const getBondAnalytics =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BOND_ANALYTICS_ACTIONS.BOND_ANALYTICS_REQUEST,
            payload: { isBondsAnalyticsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.getBondAnalytics, body })
                .then((data: any) => {
                    dispatch({ type: BOND_ANALYTICS_ACTIONS.BOND_ANALYTICS_RESPONSE, payload: data });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BOND_ANALYTICS_ACTIONS.BOND_ANALYTICS_ERROR, payload: [] });
                    reject(error);
                });
        });
    };




export const getBondInfo =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BOND_DETAIL_ACTIONS.BOND_DETAIL_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.getbondsDetailData, body })
                .then((data: any) => {
                    dispatch({ type: BOND_DETAIL_ACTIONS.BOND_DETAIL_RESPONSE, payload: data });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({ type: BOND_DETAIL_ACTIONS.BOND_DETAIL_ERROR, payload: [] });
                    reject(error);
                });
        });
    };

export const getBondPrice =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BOND_PRICE_ACTIONS.GET_BOND_PRICE_CHARTS_REQUEST,
            payload: { isBoandsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.bondPriceCharts, body })
                .then((data: any) => {
                    dispatch({
                        type: BOND_PRICE_ACTIONS.GET_BOND_PRICE_CHARTS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: BOND_PRICE_ACTIONS.GET_BOND_PRICE_CHARTS_ERROR,
                        payload: [],
                    });
                    reject(error);
                });
        });
    };
export const getBondDetailToken =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: BOND_DETAIL_TOKEN_ACTIONS.BOND_DETAIL_TOKEN_REQUEST,
            payload: { isBondsDetailTokenLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.bondDetailToken, body })
                .then((data: any) => {
                    dispatch({
                        type: BOND_DETAIL_TOKEN_ACTIONS.BOND_DETAIL_TOKEN_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: BOND_DETAIL_TOKEN_ACTIONS.BOND_DETAIL_TOKEN_ERROR,
                        payload: {},
                    });
                    reject(error);
                });
        });
    };
export const getSameIssuerBonds =
    (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
        dispatch({
            type: SAME_ISSUER_BONDS_ACTIONS.SAME_ISSUER_BONDS_REQUEST,
            payload: { isSameIssuerBondsLoader: true },
        });
        return new Promise((resolve, reject) => {
            api({ ...bonds.sameIssuerBonds, body })
                .then((data: any) => {
                    dispatch({
                        type: SAME_ISSUER_BONDS_ACTIONS.SAME_ISSUER_BONDS_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    dispatch({
                        type: SAME_ISSUER_BONDS_ACTIONS.SAME_ISSUER_BONDS_ERROR,
                        payload: {},
                    });
                    reject(error);
                });
        });
    };